import { ProgressBarVariant } from "@gx/dls/metrics/ProgressBar";

import { CreateSourceWebhookPhase } from "@/pages/sources/components/create/sources/webhook/types";

export const SOURCE_WEBHOOK_CONFIGURATION_CASE = "sourceWebhook" as const;

export const DEFAULT_SIGNATURE_HEADER = "X-Webhook-Signature";
export const DEFAULT_BATCH_INTERVAL_SECONDS = 60;
export const DEFAULT_BATCH_MAX_SIZE = 1000;

export const WEBHOOK_BASE_URL = "https://webhook.getgalaxy.io";
export const CREATE_SOURCE_WEBHOOK_FAILED_TO_CREATE_ERROR_HEADER =
  "Failed to create webhook source";

export const CREATE_SOURCE_WEBHOOK_PHASE_TO_PROGRESS_BAR_VARIANT_MAP: Record<
  CreateSourceWebhookPhase,
  ProgressBarVariant
> = {
  [CreateSourceWebhookPhase.CONFIGURE]: ProgressBarVariant.PRIMARY,
  [CreateSourceWebhookPhase.CREATING]: ProgressBarVariant.PRIMARY,
  [CreateSourceWebhookPhase.LISTENING]: ProgressBarVariant.PRIMARY,
  [CreateSourceWebhookPhase.CONFIRMED]: ProgressBarVariant.SUCCESS,
  [CreateSourceWebhookPhase.ERROR]: ProgressBarVariant.ERROR,
};
